// 如果未使用 vant 框架，请全局定义一个 class 样式，名字为该变量值，内容为 "overflow: hidden"
export var BODY_LOCK_CLASS = 'van-overflow-hidden';
var startX = 0;
var startY = 0;
var deltaX = 0;
var deltaY = 0;
var offsetX = 0;
var offsetY = 0;
var direction = '';
var totalLockCount = 0;
function isElement(node) {
  var ELEMENT_NODE_TYPE = 1;
  return node.tagName !== 'HTML' && node.tagName !== 'BODY' && node.nodeType === ELEMENT_NODE_TYPE;
}
function getScrollParent(el, root) {
  if (root === void 0) {
    root = window;
  }
  var node = el;
  while (node && node !== root && isElement(node)) {
    var {
      overflowY
    } = window.getComputedStyle(node);
    if (/scroll|auto|overlay/i.test(overflowY)) {
      return node;
    }
    node = node.parentNode;
  }
  return root;
}
function getDirection(x, y) {
  if (x > y) {
    return 'horizontal';
  }
  if (y > x) {
    return 'vertical';
  }
  return '';
}
function useTouch() {
  var isVertical = () => direction === 'vertical';
  var isHorizontal = () => direction === 'horizontal';
  var reset = () => {
    deltaX = 0;
    deltaY = 0;
    offsetX = 0;
    offsetY = 0;
    direction = '';
  };
  var start = event => {
    reset();
    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
  };
  var move = event => {
    var touch = event.touches[0];
    // safari back will set clientX to negative number
    deltaX = (touch.clientX < 0 ? 0 : touch.clientX) - startX;
    deltaY = touch.clientY - startY;
    offsetX = Math.abs(deltaX);
    offsetY = Math.abs(deltaY);

    // lock direction when distance is greater than a certain value
    var LOCK_DIRECTION_DISTANCE = 10;
    if (!direction || offsetX < LOCK_DIRECTION_DISTANCE && offsetY < LOCK_DIRECTION_DISTANCE) {
      direction = getDirection(offsetX, offsetY);
    }
  };
  return {
    move,
    start,
    reset,
    isVertical,
    isHorizontal
  };
}
var recordMap = new WeakMap();

/**
 * 阻止滚动穿透
 * @param rootRef 允许滚动的元素，一般为弹窗内容区域
 * @returns {unlock} 解除滚动锁定，关闭弹窗时调用
 */
export function useLockScroll(rootRef) {
  if (!rootRef) {
    return;
  }
  var touch = useTouch();
  var DIRECTION_UP = '01';
  var DIRECTION_DOWN = '10';
  var onTouchMove = event => {
    touch.move(event);
    var direction = deltaY > 0 ? DIRECTION_DOWN : DIRECTION_UP;
    var el = getScrollParent(event.target, rootRef);
    var {
      scrollHeight,
      offsetHeight,
      scrollTop
    } = el;
    var status = '11';
    if (scrollTop === 0) {
      status = offsetHeight >= scrollHeight ? '00' : '01';
    } else if (scrollTop + offsetHeight >= scrollHeight) {
      status = '10';
    }
    if (status !== '11' && touch.isVertical() && !(parseInt(status, 2) & parseInt(direction, 2))) {
      if (typeof event.cancelable !== 'boolean' || event.cancelable) {
        event.preventDefault();
      }
      event.stopPropagation();
    }
  };
  var lock = () => {
    if (recordMap.has(rootRef)) {
      return;
    }
    document.addEventListener('touchstart', touch.start);
    document.addEventListener('touchmove', onTouchMove, {
      passive: false
    });
    recordMap.set(rootRef, true);
    if (!totalLockCount) {
      document.body.classList.add(BODY_LOCK_CLASS);
    }
    totalLockCount++;
  };
  var unlock = () => {
    if (totalLockCount && recordMap.has(rootRef)) {
      document.removeEventListener('touchstart', touch.start);
      document.removeEventListener('touchmove', onTouchMove);
      recordMap.delete(rootRef);
      totalLockCount--;
      if (!totalLockCount) {
        document.body.classList.remove(BODY_LOCK_CLASS);
      }
    }
  };
  lock();
  return unlock;
}